<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Supportive Bank</div>
        <div>
          <bread-crumb :bread-crumbs="['Supportive Bank']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <!-- <v-toolbar flat dense>
          <v-toolbar-title></v-toolbar-title>
        </v-toolbar> -->
      <div>
        <v-row justify="center">
          <v-alert
            v-if="alertMsg.status"
            :timeout="alertMsg.timeout"
            :color="alertMsg.color"
            :type="alertMsg.type"
            dismissible
            dark
            dense
          >
            {{ alertMsg.text }}
          </v-alert>
        </v-row>
      </div>
      <v-card-text class="mt-5">
         <!--<v-row class="ms-1 me-1 mt-3">
          <v-col cols="12" md="2" lg="2" xs="12" class="mt-6">
            <v-text-field
              clearable
              dense
              outlined
              placeholder="Country Name"
            ></v-text-field>
          </v-col>
          
          <v-col cols="12" md="2" lg="2" xs="12" class="mt-6">
            <v-text-field
              clearable
              dense
              outlined
              placeholder="Bank Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" lg="2" xs="12" class="mt-6">
            <v-autocomplete
              clearable
              dense
              outlined
              placeholder="Status"
            ></v-autocomplete>
          </v-col>
          <div>
            <v-btn depressed  small class="mt-6 text-capitalize" color="primary"
              >Search</v-btn
            >
          </div>

          <template>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn depressed 
                  small
                  color="primary"
                  dark
                  outlined
                  class="mt-6 ms-2 text-capitalize"
                  v-bind="attrs"
                  v-on="on"
                >
                  Add
                </v-btn>
              </template>
              <v-card>
                <v-toolbar color="grey lighten-3 font-weight-bold" flat dense>
                  <span class="subtitleFontsize">{{ formTitle }}</span>
                  <v-spacer></v-spacer>
                  <v-btn depressed  small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text class="mt-5">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="!addmasterbranch.bank_id"
                      ><label class="my-0 labelFontsize"> Swift Bank </label>
                      <v-autocomplete
                        :items="items"
                        class="rounded"
                        dense
                        outlined
                        v-model="addmasterbranch.swift_bank"
                        :error-messages="swithbank"
                        @input="$v.addmasterbranch.swift_bank.$touch()"
                        @blur="$v.addmasterbranch.swift_bank.$touch()"
                        placeholder="Swift Bank"
                        disabled
                        background-color="grey lighten-4"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="addmasterbranch.bank_id"
                      ><label class="my-0 labelFontsize"> Swift Bank </label>
                      <v-autocomplete
                        :items="items"
                        class="rounded"
                        dense
                        outlined
                        v-model="addmasterbranch.swift_bank"
                        :error-messages="swithbank"
                        @input="$v.addmasterbranch.swift_bank.$touch()"
                        @blur="$v.addmasterbranch.swift_bank.$touch()"
                        placeholder="Swift Bank"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"
                      ><label class="my-0 labelFontsize"> Country </label>
                      <v-autocomplete
                        :items="CountryList"
                        class="rounded"
                        dense
                        outlined
                        v-model="addmasterbranch.country_name"
                        :error-messages="country"
                        @input="$v.addmasterbranch.country_name.$touch()"
                        @blur="$v.addmasterbranch.country_name.$touch()"
                        placeholder="Country"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"
                      ><label class="my-0 labelFontsize">Bank Name</label>
                      <v-text-field
                        class="rounded"
                        dense
                        outlined
                        placeholder="Bank Name"
                        v-model="addmasterbranch.name"
                        :error-messages="bankname"
                        @input="$v.addmasterbranch.name.$touch()"
                        @blur="$v.addmasterbranch.name.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6"><label class="my-0 labelFontsize"> Bank Code </label>
                      <v-text-field class="labelFontsize  rounded" dense outlined placeholder="Bank Code"
                        v-model="addmasterbranch.country_code" :error-messages="bankcode"
                        @input="$v.addmasterbranch.country_code.$touch()"
                        @blur="$v.addmasterbranch.country_code.$touch()"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <label class="my-0 labelFontsize"> Status </label>
                      <v-autocomplete
                        class="rounded"
                        dense
                        outlined
                        :items="item1"
                        placeholder="Status"
                        v-model="addmasterbranch.is_active"
                        :error-messages="status"
                        @input="$v.addmasterbranch.is_active.$touch()"
                        @blur="$v.addmasterbranch.is_active.$touch()"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn depressed 
                    color="primary"
                    small
                    class="text-capitalize"
                    @click="onclickNext()"
                    v-if="!addmasterbranch.bank_id"
                  >
                    Add
                  </v-btn>
                  <v-btn depressed 
                    color="primary"
                    small
                    class="text-capitalize ms-2"
                    @click="close"
                    outlined
                    v-if="!addmasterbranch.bank_id"
                  >
                    Cancel
                  </v-btn>
                  <v-btn depressed 
                    color="primary"
                    small
                    class="text-capitalize"
                    @click="update()"
                    v-if="addmasterbranch.bank_id"
                  >
                  <v-icon small class="me-2">mdi-content-save-edit-outline</v-icon> Update
                  </v-btn>
                  <v-btn depressed 
                    color="primary"
                    small
                    class="text-capitalize ms-2"
                    @click="close"
                    outlined
                    v-if="addmasterbranch.bank_id"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-row>
        <v-row class="mb-5">
          <v-col cols="12" md="3" lg="3" xs="12"></v-col>
          <v-col cols="12" md="5" lg="5" xs="12"></v-col>
          <v-col cols="12" md="4" lg="4" xs="12"
            ><v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to search the table data."
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field
          ></v-col>
        </v-row>  -->
        <v-row class="mb-3">
          <v-btn depressed  @click="downloadExcelsheet" class="mt-1 ms-3"  color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        </v-row>
        <v-data-table fixed-header  height="55vh" :headers="headers" :items="banklist" dense>
          <template v-slot:item.actions="{ item }">
            <v-icon small color="primary" class="mr-2" @click="editItem(item)">
              mdi-content-save-edit-outline
            </v-icon>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon color="grey" class="mr-2" @click="nextpage(item)">
              mdi-chevron-right-circle
            </v-icon>
          </template>
          <template v-slot:item.is_active="{ item }">
            <v-switch
              v-model="item.is_active"
              height="0px"
              dense
              color="success"
            ></v-switch>
          </template>
        </v-data-table>
      </v-card-text>
     
      <loading :active="loader" :opacity="0.9" color="#ff6b00" />
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import axios from "axios";
import Loading from "vue-loading-overlay";
import { required } from "vuelidate/lib/validators";
import { alpha } from "@/utils/validate";
export default {
  name: "Supportive Bank",
  data: () => ({
    editedIndex: -1,
    dialog: false,
    search: "",
    CountryList: [],
    banklist: [],
    loader: false,
    items: ["YES", "NO", "BOTH"],
    item1: ["Active", "In-Active"],
    headers: [
      {
        text: "Country Name",
        align: "start",
        sortable: false,
        value: "country_name",
      },
      // { text: "Bank Code", value: "code" },
      { text: "Bank Name", value: "name" },
      { text: "Status", value: "is_active", sortable: false },
      { text: "Edit", value: "actions", align: "center" },
    //   { text: "Navigation", value: "action", align: "center" },
    ],

    addmasterbranch: {
      name: "",
      country_name: "",
      country_code: "",
      is_active: "Active",
      swift_bank: "NO",
    },
    defaultItem: {
      name: "",
      country_name: "",
      country_code: "",
      is_active: "",
      swift_bank: "NO",
    },

    alertMsg: {
      status: false,
      text: "",
      timeout: 2000,
      color: "",
      type: "info",
    },
  }),
  components: {
    BreadCrumb,
    Loading,
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Add Master Branch"
        : "Edit Master Branch";
    },
    swithbank() {
      const errors = [];
      if (!this.$v.addmasterbranch.swift_bank.$dirty) return errors;
      !this.$v.addmasterbranch.swift_bank.required &&
        errors.push(this.$t("Swift Bank is requried"));
      return errors;
    },
    country() {
      const errors = [];
      if (!this.$v.addmasterbranch.country_name.$dirty) return errors;
      !this.$v.addmasterbranch.country_name.required &&
        errors.push(this.$t("Country is requried"));
      return errors;
    },
    status() {
      const errors = [];
      if (!this.$v.addmasterbranch.is_active.$dirty) return errors;
      !this.$v.addmasterbranch.is_active.required &&
        errors.push(this.$t("Swift Bank is requried"));
      return errors;
    },
    bankname() {
      // console.log("log", this.$v);
      const errors = [];
      if (!this.$v.addmasterbranch.name.$dirty) return errors;
      !this.$v.addmasterbranch.name.required &&
        errors.push(this.$t("Bank name is requried"));
      !this.$v.addmasterbranch.name.alpha &&
        errors.push(this.$t("invalid_first_name"));
      return errors;
    },
    // bankcode() {
    //   const errors = [];
    //   if (!this.$v.addmasterbranch.country_code.$dirty) return errors;
    //   !this.$v.addmasterbranch.country_code.required &&
    //     errors.push(this.$t("Bank code is requried"));
    //   return errors;
    // },
  },
  validations() {
    return {
      addmasterbranch: {
        swift_bank: {
          required,
        },
        country_name: {
          required,
        },
        is_active: {
          required,
        },
        name: {
          required,
          alpha,
        },
      },
    };
  },

  mounted() {
    this.getcountryList();
    this.allbanklist();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    async downloadExcelsheet() {
      if (this.banklist) {
        this.exportToExcel(this.headers, this.banklist, "Suportive_bank_list");
      }
    },
    getcountryList() {
      axios({
        url: `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/integrate/get-all-country-data`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.CountryList = response.data.map((i) => {
              return { text: i.country_name, values: i.iso_alpha3 };
            });
          }
          console.log("Country", response);
        })
        .catch((e) => {
          console.error(e);
          this.CountryList = [];
        });
    },

    allbanklist() {
      (this.isLoading = true),
        axios({
          url: `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/bank-branch/get-all-master-bank`,
          headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
            accept: "application/json",
          },
        })
          .then((response) => {
            this.isLoading = false;
            if (response.status === 200) {
              this.banklist = response.data.data;
              console.log("active", this.banklist.is_active);
              // if (this.banklist.is_active) {
              //   this.addmasterbranch.is_active = "Active"
              // } else {
              //   this.addmasterbranch.is_active = "In-Active"
              // }
            }
            console.log("banklist", response);
          })
          .catch((e) => {
            this.isLoading = false;
            console.error(e);
          });
    },

    editItem(item) {
      this.editedIndex = this.banklist.indexOf(item);
      // this.allbanklist();
      // this.getcountryList();
      this.addmasterbranch = Object.assign({}, item);
      if (this.addmasterbranch.is_active) {
        this.addmasterbranch.is_active = "Active";
      } else {
        this.addmasterbranch.is_active = "In-Active";
      }
      this.dialog = true;
    },

    onclickNext() {
      console.log(`addmasterbranch: ${JSON.stringify(this.addmasterbranch)}`);
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$emit("onNextClick", this.addmasterbranch);
      this.save();
    },

    ClickBack() {
      this.$emit("onClickBack");
    },

    save() {
      this.loader = true;
      if (this.editedIndex > -1) {
        Object.assign(this.banklist[this.editedIndex], this.addmasterbranch);
      } else {
        // console.log("bank", this.addmasterbranch)
        if (this.addmasterbranch.is_active == "Active") {
          this.addmasterbranch.is_active = true;
        } else {
          this.addmasterbranch.is_active = false;
        }
        axios
          .post(
            `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/bank-branch/add-to-master-bank`,
            this.addmasterbranch,

            {
              headers: {
                ContentType: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
                accept: "application/json",
              },
            },
            setTimeout(() => {
              this.loader = false;
            }, 400)
          )
          .then((responseData) => {
            console.log(`responseData: ${JSON.stringify(responseData)}`);
            if (responseData && responseData.data.status_code == 200) {
              this.alertMsg.status = true;
              this.allbanklist();
              this.alertMsg.text = responseData.data.message;
              this.alertMsg.type = "success";
              this.alertMsg.color = "green";
            } else {
              this.alertMsg.status = true;
              this.alertMsg.text =
                "Invalid credentials provided in the request!";
              this.alertMsg.type = "error";
              this.alertMsg.color = "warning";
            }
            console.log("respose data", responseData);
          })
          .catch((error) => {
            console.log(error.response);
            this.alertMsg.status = true;
            this.alertMsg.text = "One or more parameter is invalid or missing!";
            this.alertMsg.type = "error";
            this.alertMsg.color = "error";
          });
      }
      this.close();
    },
    update() {
      this.loader = true;
      if (this.editedIndex < -1) {
        Object.assign(this.banklist[this.editedIndex], this.addmasterbranch);
      } else {
        // this.Collectiondata.currency_code = "MYR"
        if (this.addmasterbranch.is_active == "Active") {
          this.addmasterbranch.is_active = true;
        } else {
          this.addmasterbranch.is_active = false;
        }
        axios
          .put(
            `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/bank-branch/update-master-bank?bank_id=` +
              this.addmasterbranch.bank_id,
            this.addmasterbranch,

            {
              headers: {
                ContentType: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
                accept: "application/json",
              },
            },
            setTimeout(() => {
              this.loader = false;
            }, 300)
          )

          .then((responseData) => {
            console.log(`responseData: ${JSON.stringify(responseData)}`);
            if (responseData && responseData.data.status_code == 200) {
              this.alertMsg.status = true;
              this.allbanklist();
              this.alertMsg.text = responseData.data.message;
              this.alertMsg.type = "success";
              this.alertMsg.color = "green";
            } else {
              this.alertMsg.status = true;
              this.alertMsg.text =
                "Invalid credentials provided in the request!";
              this.alertMsg.type = "error";
              this.alertMsg.color = "warning";
            }
            console.log("respose data", responseData);
          })
          .catch((error) => {
            console.log(error.response);
            this.alertMsg.status = true;
            this.alertMsg.text = "One or more parameter is invalid or missing!";
            this.alertMsg.type = "error";
            this.alertMsg.color = "error";
          });
      }

      this.close();
    },
    nextpage(item) {
      console.log("item " + item);
      this.$router.push({
        name: "Master Branch",
        query: { id: item },
      });
    },
    close() {
      this.dialog = false;
      this.$v.$reset();
      this.$nextTick(() => {
        this.addmasterbranch = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
